/* eslint-disable no-secrets/no-secrets */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import metadata from './PolicyCoveragesAccordion.metadata.json5';
import styles from './PolicyCoveragesAccordion.module.scss'

function PolicyCoveragesAccordion(props) {
    const { value: currentPeriodDetails } = props;
    const [initialSubmission] = useState(null);
   
    const renderValueField = useCallback((rowData, rowIndex) => (
        <CurrencyField
            id={`creditAmount_${rowIndex}`}
            value={rowData.amount}
            readOnly
            hideLabel
        />
    ), []);

    const renderNameField = useCallback((rowData) => <span>{rowData.name}</span>, []);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        baseCoveragesComponent: {
            value: _.get(currentPeriodDetails, 'lobs.homeOwners.baseCoverages_TWIA'),
            path: 'lobs.homeOwners.baseCoverages_TWIA',
            initialSubmission,
            additionalFieldsPath: "lobs.homeOwners.additionalCoverages_TWIA",
            disableAdditionalFields: _.get(initialSubmission, 'lobData.value.homeowners.coverables.construction.msbEligiblePolicyType_TWIA'),
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: false,
            showAmount: true,
            showCoverageNameAmount: false
        },
        additionalCoveragesComponent: {
            value: _.get(currentPeriodDetails, 'lobs.homeOwners.additionalCoverages_TWIA'),
            path: "lobs.homeOwners.additionalCoverages_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: true,
            showAmount: true,
            showCoverageNameAmount: false // DE17056
        },
        exclusionConditionsComponent: {
            value: _.get(currentPeriodDetails, 'lobs.homeOwners.exclusions_TWIA'),
            path: "lobs.homeOwners.exclusions_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: true,
            showAmount: true,
            showCoverageNameAmount: false
        },
        indirectLossCovComponent: {
            value: _.get(currentPeriodDetails, 'lobs.homeOwners.indirectLossCoverages_TWIA'),
            path: "lobs.homeOwners.indirectLossCoverages_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: true,
            showAmount: true,
            showCoverageNameAmount: false
        },
        creditSurchargesTitle: {
            // DE15705
            visible:
                _.get(currentPeriodDetails, 'lobs.homeOwners.creditsAndSurchages_TWIA') !== undefined
        },
        creditAndSurchargesTable: {
            visible:
                _.get(currentPeriodDetails, 'lobs.homeOwners.creditsAndSurchages_TWIA') !== undefined,
            data: _.get(currentPeriodDetails, 'lobs.homeOwners.creditsAndSurchages_TWIA')
        },
        totalBaseCovPremium: {
            visible:
                _.get(currentPeriodDetails, 'lobs.homeOwners.baseCoveragesTotal_TWIA') !== undefined,
            value: _.get(currentPeriodDetails, 'lobs.homeOwners.baseCoveragesTotal_TWIA')
        },
        lineTitle: {
            className:
                _.get(currentPeriodDetails, 'lobs.homeOwners.baseCoveragesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        totalAddlCovPremium: {
            visible:
                _.get(currentPeriodDetails, 'lobs.homeOwners.additionalCoveragesTotal_TWIA') !== undefined,
            value: _.get(currentPeriodDetails, 'lobs.homeOwners.additionalCoveragesTotal_TWIA')
        },
        additionalTitle: {
            className:
                _.get(currentPeriodDetails, 'lobs.homeOwners.additionalCoveragesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        totalIndirectCovPremium: {
            visible:
                _.get(currentPeriodDetails, 'lobs.homeOwners.indirectLossCoveragesTotal_TWIA') !== undefined,
            value: _.get(currentPeriodDetails, 'lobs.homeOwners.indirectLossCoveragesTotal_TWIA')
        },
        indirectLossTitle: {
            className:
                _.get(currentPeriodDetails, 'lobs.homeOwners.indirectLossCoveragesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        totalCreditCovPremium: {
            visible:
                _.get(currentPeriodDetails, 'lobs.homeOwners.creditsAndSurchagesTotal_TWIA') !== undefined,
            value: _.get(currentPeriodDetails, 'lobs.homeOwners.creditsAndSurchagesTotal_TWIA')
        },
        creditTitle: {
            className:
                _.get(currentPeriodDetails, 'lobs.homeOwners.creditsAndSurchagesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        totalExclCovPremium: {
            visible:
                _.get(currentPeriodDetails, 'lobs.homeOwners.exclusionsTotal_TWIA') !== undefined,
            value: _.get(currentPeriodDetails, 'lobs.homeOwners.exclusionsTotal_TWIA')
        },
        exclusionTitle: {
            className:
                _.get(currentPeriodDetails, 'lobs.homeOwners.exclusionsTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        indirectLossCoveragesTitle: {
            visible: _.get(currentPeriodDetails, 'lobs.homeOwners.indirectLossCoverages_TWIA')?.length > 0
        },
        premium: {
            visible: true // DE15834

        },
        totalPremium: {
            value: {
                amount: _.get(currentPeriodDetails, 'cost.amount'),
                currency: "USD"
            }
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
        },
        resolveCallbackMap: {
            renderCreditName: renderNameField,
            renderCreditValue: renderValueField
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={currentPeriodDetails}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

PolicyCoveragesAccordion.propTypes = {
    data: PropTypes.shape({}),
};

export default PolicyCoveragesAccordion;
